// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col {
  display: flex;
}

.quiz-slide {
  width: 100% !important;
}

.back-icon {
  font-size: 30px;
  cursor: pointer;
}

.correct-answer {
  background-color: #3fd37d !important;
}

.incorrect-answer {
  background-color: #e03838;
}

.correct-answer,
.incorrect-answer {
  font-weight: bold !important;
}

.swiper-slide {
  display: block !important;
}

.custom-ion-list {
  padding-top: 0 !important;
  background: transparent !important;
}

.align-question-title {
  width: 95vw;
  padding-right: 4px;
  text-align: center;
}

ion-item-divider {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2px;
  padding-right: 2px;
}

.question-title {
  font-size: 20px;
  font-family: var(--font);
  font-weight: 700;
  text-align: left;
}

.question-container {
  background-color: #ffffff;
  border-bottom: 1px solid var(--bg-color);
  padding: 25px 20px;
}
.question-container .question-pagination {
  font-family: var(--font);
  font-weight: 600;
  position: absolute;
  left: 22px;
  top: 1px;
}
.question-container .question-pagination .actual-page {
  font-size: 20px;
  margin-right: 2px;
}
.question-container .question-pagination .total-page {
  font-size: 12px;
}

.questions-to-user {
  position: relative;
  z-index: 99999;
}

.btn-custom-shape {
  border-radius: 15px !important;
}

.arrow-btn {
  margin-top: 5%;
  padding: 13px;
  border-radius: 50%;
  font-size: 1.1em;
}

.progress-outer {
  width: 100%;
  text-align: center;
  background-color: #f4f4f4;
  color: #fff;
}

.progress-inner {
  min-width: 15%;
  white-space: nowrap;
  overflow: hidden;
  padding: 5px;
}

.percent-align-center {
  padding-top: 4px;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* animation */
#countdown {
  position: relative;
  margin: auto;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  fill: none;
  animation: countdown 11s linear infinite forwards;
}

.container-image-question {
  width: 100%;
  height: 25vh;
  background-color: transparent;
  margin: auto;
}
.container-image-question .image-question {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
}

.header-align {
  display: block !important;
}

ion-item-divider {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.spacer {
  width: 100%;
  margin-top: 2px;
  margin-bottom: 6px;
}

.align-loader-custom {
  margin: 0 auto;
  margin-top: 0px;
  position: relative;
  top: 30px;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
}

.infobooth {
  background-color: #ffffff;
  padding: 10px 0 0 0;
}

ion-toolbar {
  border-radius: 0;
}
ion-toolbar p {
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
}

.btn-validate-quiz {
  height: 50px;
  width: 70%;
  font-family: var(--font);
  font-weight: 700;
  font-size: 16px;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-validate-quiz ion-spinner {
  margin-left: 8px;
}

.align-buttons-quiz {
  display: flex;
  justify-content: space-between;
  padding: 0 2.5%;
  margin-bottom: 10px;
}

.btn-prev {
  width: 15%;
  height: 50px;
}

.btn-next {
  height: 50px;
  width: 15%;
}

@media screen and (min-width: 768px) {
  ion-toolbar ion-title p {
    text-align: left;
  }
  .container-image-question {
    width: 100%;
    height: 46vh;
  }
  .question-container {
    padding: 20px 40px;
  }
  .question-container .question-pagination {
    left: 40px;
    top: 20px;
  }
  .question-without-img {
    margin-top: 20px;
  }
}
.label-choice {
  font-size: 1rem !important;
  font-weight: bolder;
  font-family: var(--font) !important;
}

ion-progress-bar {
  --background: #f4f4f4;
  --progress-background: var(--menu-color) ;
}

ion-button {
  font-weight: 700;
  text-transform: none;
  --background: var(--link-color);
  --background-hover: var(--link-color);
  --color: var(--btn-text-color);
  --border-radius: 0;
  --box-shadow: 0 2px 6px 0 rgb(0, 0, 0, 0.25);
}

ion-footer {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/quiz/quiz.page.scss"],"names":[],"mappings":"AAKA;EACI,aAAA;AAJJ;;AAOA;EACI,sBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,eAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EACI,yBAAA;AAJJ;;AAOA;;EAEI,4BAAA;AAJJ;;AAOA;EACI,yBAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;AAJJ;;AAOA;EAEI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,gBAAA;AAJJ;;AAOA;EAEI,yBAAA;EACA,wCAAA;EACA,kBAAA;AALJ;AAOI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,kBAAA;EACA,UAAA;EACA,QAAA;AAJR;AAMQ;EACI,eAAA;EACA,iBAAA;AAJZ;AAOQ;EACI,eAAA;AALZ;;AAUA;EACI,kBAAA;EACA,cAAA;AAPJ;;AAUA;EACI,8BAAA;AAPJ;;AAUA;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,WAAA;EAGA,kBAAA;EACA,yBAAA;EAEA,WAAA;AAVJ;;AAcA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAXJ;;AAeA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAZJ;;AAeA,cAAA;AACA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,qBAAA;EACA,iBAAA;AAZJ;;AAeA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;AAZJ;;AAeA;EACI,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,iDAAA;AAZJ;;AAiBA;EACI,WAAA;EACA,YAAA;EAEA,6BAAA;EACA,YAAA;AAfJ;AAiBI;EACI,WAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;AAfR;;AAmBA;EACI,yBAAA;AAhBJ;;AAmBA;EACI,0BAAA;EACA,6BAAA;AAhBJ;;AAmBA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;AAhBJ;;AAmBA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AAhBJ;;AAmBA;EACI,yBAAA;EACA,mBAAA;AAhBJ;;AAmBA;EACI,gBAAA;AAhBJ;AAkBI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAfR;;AAmBA;EACI,YAAA;EACA,UAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,oBAAA;EAMA,aAAA;EACA,uBAAA;EACA,mBAAA;AApBJ;AAqBI;EACI,gBAAA;AAnBR;;AAuBA;EACI,aAAA;EAEA,8BAAA;EACA,eAAA;EACA,mBAAA;AArBJ;;AAwBA;EACI,UAAA;EACA,YAAA;AArBJ;;AA2CA;EACI,YAAA;EACA,UAAA;AAxCJ;;AA8DA;EAIQ;IACI,gBAAA;EA9DV;EAkEE;IACI,WAAA;IACA,YAAA;EAhEN;EAmEE;IACI,kBAAA;EAjEN;EAmEM;IACI,UAAA;IACA,SAAA;EAjEV;EAqEE;IACI,gBAAA;EAnEN;AACF;AAsEA;EACI,0BAAA;EACA,mBAAA;EACA,mCAAA;AApEJ;;AAuEA;EACI,qBAAA;EACA,yCAAA;AApEJ;;AAuEA;EAMI,gBAAA;EACA,oBAAA;EAEA,+BAAA;EACA,qCAAA;EAEA,8BAAA;EACA,kBAAA;EACA,4CAAA;AA3EJ;;AA8EA;EACI,aAAA;AA3EJ","sourcesContent":["// :host {\n//     width: 100%;\n//     height: 100%;\n// }\n\nion-col {\n    display: flex;\n}\n\n.quiz-slide {\n    width: 100% !important;\n}\n\n.back-icon {\n    font-size: 30px;\n    cursor: pointer;\n}\n\n.correct-answer {\n    background-color: #3fd37d !important;\n}\n\n.incorrect-answer {\n    background-color: #e03838;\n}\n\n.correct-answer,\n.incorrect-answer {\n    font-weight: bold !important;\n}\n\n.swiper-slide {\n    display: block !important;\n}\n\n.custom-ion-list {\n    padding-top: 0 !important;\n    background: transparent !important;\n}\n\n.align-question-title {\n    width: 95vw;\n    padding-right: 4px;\n    text-align: center;\n}\n\nion-item-divider {\n    // width: 100vw;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 2px;\n    padding-right: 2px;\n}\n\n.question-title {\n    font-size: 20px;\n    font-family: var(--font); font-weight: 700;;\n    text-align: left;\n}\n\n.question-container {\n    // background-color: var(--bg-color);\n    background-color: #ffffff;\n    border-bottom: 1px solid var(--bg-color) ;\n    padding: 25px 20px;\n\n    .question-pagination {\n        font-family: var(--font); font-weight: 600;;\n        position: absolute;\n        left: 22px;\n        top: 1px;\n\n        .actual-page {\n            font-size: 20px;\n            margin-right: 2px;\n        }\n\n        .total-page {\n            font-size: 12px;\n        }\n    }\n}\n\n.questions-to-user {\n    position: relative;\n    z-index: 99999;\n}\n\n.btn-custom-shape {\n    border-radius: 15px !important;\n}\n\n.arrow-btn {\n    margin-top: 5%;\n    padding: 13px;\n    border-radius: 50%;\n    font-size: 1.1em;\n}\n\n.progress-outer {\n    width: 100%;\n    // margin: 10px 2%;\n    // padding: 3px;\n    text-align: center;\n    background-color: #f4f4f4;\n    // border: 1px solid #dcdcdc;\n    color: #fff;\n    // border-radius: 7px;\n}\n\n.progress-inner {\n    min-width: 15%;\n    white-space: nowrap;\n    overflow: hidden;\n    padding: 5px;\n    // border-radius: 7px;\n}\n\n.percent-align-center {\n    padding-top: 4px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n/* animation */\n#countdown {\n    position: relative;\n    margin: auto;\n    height: 40px;\n    width: 40px;\n    text-align: center;\n}\n\n#countdown-number {\n    display: inline-block;\n    line-height: 40px;\n}\n\nsvg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 40px;\n    height: 40px;\n    transform: rotateY(-180deg) rotateZ(-90deg);\n}\n\nsvg circle {\n    stroke-dasharray: 113px;\n    stroke-dashoffset: 0px;\n    stroke-linecap: round;\n    stroke-width: 2px;\n    fill: none;\n    animation: countdown 11s linear infinite forwards;\n}\n\n\n\n.container-image-question {\n    width: 100%;\n    height: 25vh;\n    // background-color: #ffffff;\n    background-color: transparent;\n    margin: auto;\n\n    .image-question {\n        width: 100%;\n        height: 100%;\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n        border-radius: 10px;\n    }\n}\n\n.header-align {\n    display: block !important;\n}\n\nion-item-divider {\n    margin-top: 5px !important;\n    margin-bottom: 5px !important;\n}\n\n.spacer {\n    width: 100%;\n    margin-top: 2px;\n    margin-bottom: 6px;\n}\n\n.align-loader-custom {\n    margin: 0 auto;\n    margin-top: 0px;\n    position: relative;\n    top: 30px;\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n}\n\n.infobooth {\n    background-color: #ffffff;\n    padding: 10px 0 0 0;\n}\n\nion-toolbar {\n    border-radius: 0;\n\n    p {\n        font-family: var(--font); font-weight: 700;;\n        font-size: 20px;\n    }\n}\n\n.btn-validate-quiz {\n    height: 50px;\n    width: 70%;\n    font-family: var(--font); font-weight: 700;;\n    font-size: 16px;\n    text-transform: none;\n    //border-radius: 28px;\n    //margin-bottom: 10px;\n    //position: absolute;\n    //left: 12.5%;\n    //z-index: 444;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    ion-spinner {\n        margin-left: 8px;\n    }\n}\n\n.align-buttons-quiz {\n    display: flex;\n    //position: relative;\n    justify-content: space-between;\n    padding: 0 2.5%;\n    margin-bottom: 10px;\n}\n\n.btn-prev {\n    width: 15%;\n    height: 50px;\n    //position: relative;\n    //border-radius: 28px 0 0 28px;\n\n    // >.curve {\n    //     height: 103%;\n    //     background: #ffffff;\n    //     width: 80%;\n    //     position: absolute;\n    //     border-radius: 28px 0 0 28px;\n    //     right: 0;\n    //     top: -1px;\n    //     cursor: auto;\n    // }\n\n    // >ion-icon {\n    //     position: absolute;\n    //     left: 9.5%;\n    //     top: 17px;\n    // }\n}\n\n.btn-next {\n    height: 50px;\n    width: 15%;\n    //position: relative;\n    //border-radius: 0 28px 28px 0;\n\n    // >.curve {\n    //     height: 103%;\n    //     background: #ffffff;\n    //     width: 80%;\n    //     position: absolute;\n    //     border-radius: 0 28px 28px 0;\n    //     left: -1px;\n    //     top: -1px;\n    //     cursor: auto;\n    // }\n\n    // >ion-icon {\n    //     position: absolute;\n    //     right: 9.5%;\n    //     top: 17px;\n    // }\n}\n\n@media screen and (min-width: 768px) {\n    ion-toolbar {\n\n        // border-radius: 37px;\n        ion-title p {\n            text-align: left;\n        }\n    }\n\n    .container-image-question {\n        width: 100%;\n        height: 46vh;\n    }\n\n    .question-container {\n        padding: 20px 40px;\n\n        .question-pagination {\n            left: 40px;\n            top: 20px;\n        }\n    }\n\n    .question-without-img {\n        margin-top: 20px;\n    }\n}\n\n.label-choice{\n    font-size: 1rem !important;\n    font-weight: bolder;\n    font-family: var(--font) !important;\n}\n\nion-progress-bar {\n    --background: #f4f4f4;\n    --progress-background: var(--menu-color)\n}\n\nion-button {\n    //height: 45px;\n    //width: 90%;\n    //margin: 10px auto;\n    \n    //font-family: var(--font);\n    font-weight: 700;\n    text-transform: none;\n\n    --background: var(--link-color);\n    --background-hover: var(--link-color);\n\n    --color: var(--btn-text-color);\n    --border-radius: 0;\n    --box-shadow: 0 2px 6px 0 rgb(0, 0, 0, 0.25);\n}\n\nion-footer {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
